"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useDragDropManager_1 = require("./internal/useDragDropManager");

var useDropTargetHandler_1 = require("./internal/useDropTargetHandler");

var useMonitorOutput_1 = require("./internal/useMonitorOutput");

var useDropTargetMonitor_1 = require("./internal/useDropTargetMonitor");
/**
 * useDropTarget Hook (This API is experimental and subject to breaking changes in non-breaking versions)
 * @param spec The drop target specification
 */


function useDrop(spec) {
  var ref = spec.ref,
      type = spec.type,
      dropTargetOptions = spec.dropTargetOptions,
      collect = spec.collect;
  var manager = useDragDropManager_1.useDragDropManager();
  var backend = manager.getBackend();
  var handler = useDropTargetHandler_1.useDropTargetHandler(spec);
  var targetMonitor = useDropTargetMonitor_1.useDropTargetMonitor(type, handler, manager);
  /*
   * Connect the Drop Target Element to the Backend
   */

  react_1.useEffect(function connectDropTarget() {
    if (ref && ref.current) {
      var dropTargetNode = ref.current;

      if (dropTargetNode) {
        return backend.connectDropTarget(targetMonitor.getHandlerId(), dropTargetNode, dropTargetOptions);
      }
    }
  });

  if (collect) {
    return useMonitorOutput_1.useMonitorOutput(targetMonitor, collect);
  } else {
    return {};
  }
}

exports.useDrop = useDrop;